// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cSxv","selected":"styles_selected__12ioe"};